import styled from "styled-components";
import fipayFonts from "../../theme/index";

interface TextFieldsDropDownProps {
  width?: string;
}

interface InputFieldProps {
  width?: string;
  height?: string;
  fontSize?: string;
}

export const Wrapper = styled.div`
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 15px;
  position: relative;
  @media screen and (max-width: 1024px) and (max-height: 600px) {
    padding-bottom: 0px;
  }

  @media screen and (max-width: 540px) {
    padding: 5px;
  }
  @media screen and (max-width: 375px) {
    padding: 5px;
    width: 90%;
    margin: 0 auto;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 20px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  letter-spacing: 2%;
`;

export const InputField = styled.input<InputFieldProps>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "30px"};
  text-indent: 10px;
  padding: 10px;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  resize: vertical;
  overflow: auto;
  // text-align: center;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;

  font-family: "Gt Walsheim Pro", sans-serif;

  &::placeholder {
    color: #0e0e0e;
    font-size: font-size: ${(props) => props.fontSize || fipayFonts.fipayFonts.fontSize.body2};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.6;
  }

  &[type="password"] {
    font-size: ${fipayFonts.fipayFonts.fontSize.heading3};
    position: relative;
  }

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }

  @media screen and (max-width: 1024px) and (max-height: 600px) {
    
  }

  @media screen and (max-width: 912px) and (max-height: 1368px) {
  }

  @media screen and (max-width: 768px) {
    padding: 4.5px;
    
  }

  @media screen and (max-width: 540px) {
    padding: 4px;
     width: 100%;
  }

  @media screen and (max-width: 414px) {
    padding-top: 10px;
     width: 100%;
  }

  // @media screen and (max-width: 390px) {
  //   padding: 0px;
  //   height: 50px;
  // }

  @media screen and (max-width: 375px) {
    padding: 0px;
    width: 100%;
  }
`;

export const EyeIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: 3%;
  cursor: pointer;

  svg {
    width: 1.3rem;
    height: 1.3rem;
  }
`;

export const WrapperDropDown = styled.div`
  // margin-bottom: 10px;
  width: 100%;
  padding: 20px;
  position: relative;
  @media screen and (max-width: 1024px) and (max-height: 600px) {
    padding-bottom: 0px;
    width: 95%;
  }
  @media screen and (max-width: 768px) {
    padding: 10px;
    width: 95%;
  }

  @media screen and (max-width: 540px) {
    padding: 4px;
    width: 100%;
  }

  @media screen and (max-width: 412px) {
  }
  @media screen and (max-width: 375px) {
    padding: 10px;
    margin-bottom: 8px;
  }
`;

export const SelectField = styled.select<TextFieldsDropDownProps>`
  width: ${(props) => props.width || "95%"};
  padding: 15px;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-family: "Gt Walsheim Pro", sans-serif;
  opacity: 0.6;
  &:focus {
    border: 1px solid #3f4188;
    outline: none;
    background-color: #e9eaf9;
  }

  @media screen and (max-width: 414px) {
    padding: 5px;
    width: ${(props) => props.width || "98%"};
  }

  @media screen and (max-width: 412px) {
    padding: 5px;
    width: ${(props) => props.width || "98%"};
  }

  @media screen and (max-width: 390px) {
    padding: 5px;
    width: ${(props) => props.width || "98%"};
    height: 50px;
  }

  @media screen and (max-width: 375px) {
    padding: 5px;
    width: ${(props) => props.width || "93%"};
    height: 35px;
  }
`;

export const WrapperPhoneDropDown = styled.div`
  margin-bottom: 20px;
  width: 30%;
  padding: 20px;
`;

export const SelectPhoneField = styled.select<TextFieldsDropDownProps>`
  width: ${(props) => props.width || "100%"};
  height: 70%;
  padding: 8px;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
`;
export const WrapperImageInput = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
`;

export const ImageInputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
`;

export const ImageInputField = styled.input`
  width: 100%;
  height: 100%;
  padding: 8px;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-family: "Gt Walsheim Pro", sans-serif;
  outline: none;
`;

export const ImagePreview = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  border-radius: 15px;
`;
